<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="sAPPurchaseOrders"
        @select="selectAll"
        @select-all="selectAll">
      <div slot="toolbar" class="toolbar">
        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
        <el-button type="primary" :loading="printLoading" @click="printInvoice()">打印采购单</el-button>
        <el-button v-if="cableAuth" type="success" :loading="printLoading" @click="printInvoiceByXl()">
          打印采购单(线缆)
        </el-button>
        <el-button v-if="cableAuth" type="success" :loading="printLoading" @click="gotoCablePrint()">线缆流转单</el-button>
        <el-button type="primary" @click="billBarcode">按单条码</el-button>
        <el-button type="primary" @click="materialBarcode">物料条码</el-button>
        <el-button type="success" @click="cableBarcode">线缆条码</el-button>
        <el-button type="success" @click="cablePackBarcode">线缆包装条码</el-button>
        <el-button type="primary" @click="procureDateSubmit">按采购交期批量提交</el-button>
        <el-button type="primary" @click="customDateSubmit">自定义交期批量提交</el-button>
        <el-checkbox
            v-model="checked"
            label="隐藏金额"
            style="margin-left: 5px;border: 1px solid #e6e6e6;padding: 3px 15px 3px 7px;"/>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="采购订单号">
            <el-input
                v-model.trim="filter.buyOrderNo"
                type="textarea"
                :autosize="{ minRows:1, maxRows:6 }"
                style="width: 150px"
                clearable/>
          </vm-search>
          <vm-search label="出厂编号">
            <el-input
                v-model.trim="filter.contractNo"
                type="textarea"
                :autosize="{ minRows:1, maxRows:6 }"
                style="width: 150px"
                clearable/>
          </vm-search>
          <vm-search label="客户合同号">
            <el-input v-model.trim="filter.clientContractNO" style="width: 190px" clearable/>
          </vm-search>
          <vm-search label="供应商名称">
            <el-input v-model.trim="filter.gysName" style="width: 190px" clearable/>
          </vm-search>
          <!--          <vm-search label="物料号">-->
          <!--            <el-input v-model.trim="filter.materialNO" style="width: 150px" clearable/>-->
          <!--          </vm-search>-->
          <vm-search label="采购组">
            <el-input v-model.trim="filter.buyUserName" style="width: 150px" clearable/>
          </vm-search>
          <div class="vm-search">
            <vm-search label="接货状态">
              <el-select v-model.trim="filter.receiveStatus" placeholder="请选择">
                <el-option label="全部" :value="-1"/>
                <el-option label="供应商未确认" :value="0"/>
                <el-option label="采购退回" :value="1"/>
                <el-option label="采购未确认" :value="2"/>
                <el-option label="已确认" :value="5"/>
                <el-option label="部分创建" :value="10"/>
                <el-option label="已创建" :value="20"/>
              </el-select>
            </vm-search>
            <vm-search label="打印状态">
              <el-select v-model.trim="filter.managerID" placeholder="请选择">
                <el-option label="全部" :value="-1"/>
                <el-option label="未打印" :value="0"/>
                <el-option label="已打印" :value="1"/>
              </el-select>
            </vm-search>
            <!--            <vm-search label="类别">-->
            <!--              <el-select v-model.trim="filter.purchaseType" placeholder="请选择">-->
            <!--                <el-option label="全部" :value="0"/>-->
            <!--                <el-option label="电气" :value="1"/>-->
            <!--                <el-option label="部件" :value="2"/>-->
            <!--                <el-option label="电气部件" :value="3"/>-->
            <!--              </el-select>-->
            <!--            </vm-search>-->
            <!--            <vm-search label="大打包">-->
            <!--              <el-select v-model.trim="filter.isPacking" placeholder="请选择">-->
            <!--                <el-option label="全部" :value="-1"/>-->
            <!--                <el-option label="是" :value="1"/>-->
            <!--                <el-option label="否" :value="0"/>-->
            <!--              </el-select>-->
            <!--            </vm-search>-->
            <vm-search label="采购订单类型">
              <el-select v-model.trim="filter.production" placeholder="请选择">
                <el-option label="全部" :value="-1"/>
                <el-option label="生产" :value="0"/>
                <el-option label="非生产" :value="1"/>
              </el-select>
            </vm-search>
          </div>
          <vm-search label="交货日期">
            <div class="block">
              <el-date-picker
                  v-model="filter.beginConfirmDeliveryDate"
                  placement="bottom-start"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endConfirmDeliveryDate"
                  placement="bottom-start"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 190px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
          <vm-search label="下单日期">
            <div class="block">
              <el-date-picker
                  v-model="filter.beginAddDate"
                  placement="bottom-start"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endAddDate"
                  placement="bottom-start"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 190px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
        </div>
        <div class="vm-search">
          <!--          <vm-search label="提前交货" style="width: 80px">-->
          <!--            <el-checkbox v-model="filter.ahead" style="margin-top: 5px;"/>-->
          <!--          </vm-search>-->
          <!--          <vm-search label="逾期交货" style="width: 80px">-->
          <!--            <el-checkbox v-model="filter.overdue" style="margin-top: 5px;"/>-->
          <!--          </vm-search>-->
          <vm-search label="不显示关联公司" style="width: 80px">
            <el-checkbox v-model="filter.relatedCompany" style="margin-top: 5px;"/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-table
                :data="props.row.details"
                style="width: 100%">
              <template slot="adSearch">
                <div class="vm-search" style="width: auto;">
                  <vm-search label="物料代码">
                    <el-input v-model.trim="filters.partNo" style="width: 170px" clearable/>
                  </vm-search>
                  <vm-search label="数量">
                    <el-input v-model.trim="filters.qty" style="width: 170px" clearable/>
                  </vm-search>
                </div>
              </template>
              <el-table-column align="center" label="状态" width="60" prop="status">
                <template slot-scope="scope">
                  {{constant.purchaseOrderStatus[scope.row.status]}}
                </template>
              </el-table-column>
              <el-table-column align="center" label="物料代码" width="120" prop="partNo"/>
              <el-table-column align="center" label="物料描述" width="400" prop="partNameSpec"/>
              <el-table-column align="center" label="数量" width="100" prop="qty"/>
              <el-table-column align="center" label="入库数量" width="100" prop="hasInStorageQty"/>
              <el-table-column align="center" label="单位" width="100" prop="unit"/>
              <el-table-column align="center" label="单价" width="100" prop="unitPrice"/>
              <el-table-column align="center" label="金额" width="100" prop="price"/>
              <el-table-column align="center" label="备注" prop="remark">
                <template slot-scope="scope">
                  {{scope.row.remark + scope.row.remarkBZ}}
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center" width="45"/>
      <el-table-column prop="status" align="center" width="55px" label="状态">
        <template slot-scope="scope">
          {{constant.purchaseOrderStatus[scope.row.status]}}
        </template>
      </el-table-column>
      <el-table-column prop="priority" align="center" width="100px" label="级别">
        <template slot-scope="scope">
          {{formatter(scope.row)}}
          <!-- <span v-if="scope.row.priority === -1">全部</span> -->
        </template>
      </el-table-column>
      <el-table-column prop="receiveStatus" align="center" width="100px" label="接收状态">
        <template slot-scope="scope">
          {{getTitle(scope.row.receiveStatus)}}
        </template>
      </el-table-column>
      <el-table-column prop="buyOrderNo" width="110px" align="center" label="采购订单号">
        <template slot-scope="scope">
          <span
              style="color: #2d8cf0;cursor: pointer;"
              @click="gotoBuyOrder(scope.row)">
            {{scope.row.buyOrderNo}}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="附件" align="center" width="60px">
        <template v-slot="scope">
          <span
              v-if="scope.row.sapsalesOrderNO !== null && scope.row.sapsalesOrderNO !== '' && scope.row.gysCode === '8000041'"
              style="color: #2d8cf0;cursor: pointer"
              @click="$refs.attachment.open(scope.row.sapsalesOrderNO)">
            附件
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="salesOrderNO" align="center" label="出厂编号" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.salesOrderNO.length>10">
            <div v-for="(item,index) in (scope.row.salesOrderNO.split(','))" :key="index">
              <span style="color: #2D8CF0;cursor: pointer" @click="goto1(scope.row,item,index)">{{item}}</span>
            </div>
          </div>
          <div v-else style="color: #2D8CF0;cursor: pointer" @click="goto(scope.row)">{{scope.row.salesOrderNO}}</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="clientContractNO"
          align="center"
          label="客户合同号"
          show-overflow-tooltip
          width="120"/>
      <el-table-column prop="customerName" align="center" label="客户名称" width="230"/>
      <el-table-column prop="gysCode" align="center" label="供应商号码" width="100"/>
      <el-table-column prop="gysName" align="center" width="400" label="供应商"/>
      <el-table-column prop="managerID" align="center" label="打印次数">
        <template slot-scope="scope">
          <span v-if="scope.row.managerID === null || scope.row.managerID === 0">未打印</span>
          <span v-else>已打印</span>
        </template>
      </el-table-column>
      <el-table-column prop="buyUserName" align="center" label="采购组" width="100"/>
      <!--      <el-table-column prop="linkMan" align="center" label="联系人" width="70"/>-->
      <!--      <el-table-column prop="linkManPhone" align="center" label="电话" width="110"/>-->
      <!--      <el-table-column prop="linkManFax" align="center" label="传真" width="110"/>-->
      <el-table-column prop="addDate" align="center" label="下单日期" width="120">
        <template slot-scope="scope">
          <span>{{scope.row.addDate.slice(0, 10)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sapApproveTime" align="center" label="审核时间" width="150"/>
      <!-- <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="190px">
        <template slot-scope="scope">
          <el-button v-if="scope.row.receiveStatus === 0 || scope.row.receiveStatus === null || scope.row.receiveStatus === 10" type="primary" @click="$refs.editPurchaseOrderManager.open(scope.row.pkid)">创建收货单</el-button>
          <el-button type="primary">从SAP更新</el-button>
       </template>
      </el-table-column>  -->
    </vm-table>
    <preview ref="preview" @save-success="getList(-1)"/>
    <purchase-order-manager-edit ref="editPurchaseOrderManager" @save-success="getList(-1)"/>
    <purchase-order-attachment ref="attachment"/>
    <material-barcode-print-edit ref="materialBarcode"/>
    <custom-date-submit ref="customDate" @save-success="getList(-1)"/>
    <el-dialog
        v-el-drag-dialog
        width="400px"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="打印参数配置">
      <el-form
          ref="form"
          :model="filter"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="打印销单" prop="salesOrderPrint">
          <el-select v-model="filter.salesOrderPrint" placeholder="请选择">
            <el-option label="是" :value="true"/>
            <el-option label="否" :value="false"/>
          </el-select>
        </el-form-item>
        <el-form-item label="打印节点附件" prop="isNodeId">
          <el-select v-model="filter.isNodeId" placeholder="请选择">
            <el-option label="是" :value="true"/>
            <el-option label="否" :value="false"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="printLoadingByXl" type="primary" @click="submitHandle(true)">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
        v-el-drag-dialog
        width="400px"
        :visible.sync="noteDialogVisible"
        :close-on-click-modal="false"
        title="打印参数配置">
      <el-form
          ref="form"
          :model="filter"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="打印备注" prop="notePrint">
          <el-select v-model="filter.notePrint" placeholder="请选择">
            <el-option label="是" :value="true"/>
            <el-option label="否" :value="false"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="noteDialogVisible = false">取消</el-button>
        <el-button :loading="printLoading" type="primary" @click="submitHandle(filter.notePrint)">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "../../../util/constant";
  import PurchaseOrderManagerEdit from "@/views/purchase/purchaseOrderManager/purchaseOrderManagerEdit";
  import Preview from "@/views/purchase/purchaseOrderManager/Preview";
  import PurchaseOrderAttachment from "@/views/purchase/purchaseOrderManager/PurchaseOrderAttachment";
  import LoginUtil from "@/util/loginUtil";
  import MaterialBarcodePrintEdit from "@/views/purchase/purchaseOrderManager/MaterialBarcodePrintEdit.vue";
  import CustomDateSubmit from "@/views/purchase/purchaseOrderManager/CustomDateSubmit";

  export default {
    name: "PurchaseOrderManagerList",
    components: {
      PurchaseOrderAttachment,
      Preview,
      PurchaseOrderManagerEdit,
      VmTable,
      VmSearch,
      MaterialBarcodePrintEdit,
      CustomDateSubmit,
    },
    data() {
      return {
        constant,
        userType: LoginUtil.getUserType(),
        printLoading: false,
        printLoadingByXl: false,
        exportLoading: false,
        dialogVisible: false,
        noteDialogVisible: false,
        cableAuth: this.$auth(240),
        statu: constant.toSelect(constant.purchaseStatus, "addAll"),
        purchaseOrderStatus: constant.toSelect(constant.purchaseOrderStatus, "addAll"),
        show: "",
        receiveStatus: "",
        checked: false,
        filter: {
          receiveStatus: -1,
          buyOrderNo: "",
          contractNo: "",
          purchaseOrderNO: "",
          gysName: "",
          gysCode: "",
          gysNamePhone: "",
          beginConfirmDeliveryDate: "",
          endConfirmDeliveryDate: "",
          beginAddDate: "",
          endAddDate: "",
          purchaseType: 0,
          isPacking: -1,
          buyUserName: "",
          materialNO: "",
          managerID: -1,
          ahead: false,
          overdue: false,
          relatedCompany: true,
          production: 0,
          purchaseList: [],
          showPrice: false,
          salesOrderPrint: true,
          isNodeId: true,
          nodeId: "",
          notePrint: true,
          clientContractNO:"",
        },
        filters: {
          partNo: "",
          qty: "",
        },
        details: [],
        selection: [],
        buyOrderNoList: [],
        ruleValidate: {
          salesOrderPrint: {required: true, message: "打印销单/流水单不能为空", trigger: "blur"},
          isNodeId: {required: true, message: "打印节点附件不能为空", trigger: "blur"},
          notePrint: {required: true, message: "打印备注不能为空", trigger: "blur"},
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      getTitle(val) {
        switch (val) {
          case -1:
            return "全部";
          case 0:
            return "供应商未确认";
          case 1:
            return "采购退回";
          case 2:
            return "采购未确认";
          case 5:
            return "已确认";
          case 10:
            return "部分创建发货单";
          case 20:
            return "全部创建发货单";
        }
      },
      selectAll(selection) {
        this.selection = selection;
        this.buyOrderNoList = [];
        for (let item of this.selection) {
          this.buyOrderNoList.push(item.buyOrderNo);
        }
      },
      procureDateSubmit() {
        if (this.selection.length === 0) {
          this.$message.error("请至少选择一条记录");
          return;
        }
        let param = {
          orderVoList: this.selection,
          responseTime: null,
        };
        this.$http.post("basic", "sAPPurchaseOrders/responseDeliveryTimeList", param).then((res) => {
          this.getList(-1);
          this.$message.success("提交成功");
        });
      },
      customDateSubmit() {
        if (this.selection.length === 0) {
          this.$message.error("请至少选择一条记录");
          return;
        }
        this.$refs.customDate.open(this.selection);
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "purchaseReceives", row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      gotoBuyOrder(row) {
        this.$refs.preview.open(row);
        const element = event.target;
        element.style.textDecoration = "underline";
      },
      goto(row) {
        this.$router.push({
          path: "/salesOrderPreviewBySupplier",
          query: {
            billType: 1,
            billId: row.techParamBillIdList[0],
            salesOrderNo: row.salesOrderNO,
            $tabName: row.salesOrderNO,
          },
        });
        const element = event.target;
        element.style.textDecoration = "underline";
      },
      gotoCablePrint() {
        if (this.selection.length === 0) {
          this.$message.error("请选择至少一行记录");
          return;
        }
        this.purchaseList = [];
        for (let item of this.selection) {
          this.purchaseList.push(item.buyOrderNo);
        }
        this.$router.push({
          path: "/CablePrintProperty",
          query: {
            purchaseList: this.purchaseList,
          },
        });
      },
      // 打印采购单
      goto1(row, item,index) {
        console.log(index);
        console.log(row.techParamBillIdList);
        let billId;
        for (const elementKey in row.techParamBillIdList) {
          if (item.includes(row.techParamBillIdList[elementKey])) {
            billId = row.techParamBillIdList[elementKey];
            break;
          }
        }
        this.$router.push({
          path: "/salesOrderPreviewBySupplier",
          query: {
            billType: 1,
            billId: billId,
            salesOrderNo: item,
            $tabName: item,
          },
        });
        const element = event.target;
        element.style.textDecoration = "underline";
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "sAPPurchaseOrders/exportSAPPurchaseOrderVO", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      // 打印采购单
      printInvoice() {
        if (this.buyOrderNoList.length === 0) {
          this.$message.error("请至少选择一条需要打印的采购单");
          return;
        }
        this.noteDialogVisible = true;
        this.filter.salesOrderPrint = false;
        this.filter.nodeId = "";
      },
      printInvoiceByXl() {
        if (this.buyOrderNoList.length === 0) {
          this.$message.error("请至少选择一条需要打印的采购单");
          return;
        }
        this.dialogVisible = true;
      },
      submitHandle(notePrint) {
        this.filter.notePrint = notePrint;
        this.filter.purchaseList = this.buyOrderNoList;
        this.filter.showPrice = !this.checked;
        if (this.filter.isNodeId) {
          this.filter.nodeId = "techForeCheck";
        } else {
          this.filter.nodeId = "0";
        }
        this.printLoadingByXl = true;
        this.$http
          .postForFile("basic", "sAPPurchaseOrders/purchaseList/", this.filter)
          .then((res) => {
            console.log(res);
            let blob = new Blob([res.data], {type: "application/pdf"});
            let pdfUrl = window.URL.createObjectURL(blob);
            window.open(pdfUrl);
            this.printLoadingByXl = false;
            this.dialogVisible = false;
            this.noteDialogVisible = false;
            this.printLoading = false;
            this.filter.purchaseList = [];
            this.getList();
          }).catch(() => {
            this.printLoadingByXl = false;
            this.dialogVisible = false;
            this.noteDialogVisible = false;
            this.printLoading = false;
          });
      },
      formatter(row) {
        let txt = row.priority > 0 ? "优先" : "正常";
        if (row.integrationTesting) {
          txt += "/联调";
        }
        return txt;
      },
      billBarcode() {
        if (this.selection.length === 0) {
          this.$message.error("请选择至少一行记录");
          return;
        }
        let ids = this.selection.map(item => item.pkid).join(",");
        window.open("http://emes.stepelectric.com/WinOpenASPX/PurchasePrintOne.aspx?SystemNo=" + ids);
      },
      materialBarcode() {
        if (this.selection.length === 0) {
          this.$message.error("请选择至少一行记录");
          return;
        }
        if (this.selection.length > 1) {
          this.$message.error("至多选择一行记录");
          return;
        }
        this.$refs.materialBarcode.open(this.selection);
      },
      cableBarcode() {
        if (this.selection.length === 0) {
          this.$message.error("请选择至少一行记录");
          return;
        }
        let ids = this.selection.map(item => item.pkid).join(",");
        window.open("http://emes.stepelectric.com/WinOpenASPX/PurchasePrintOne_XL.aspx?SystemNo=" + ids);
      },
      cablePackBarcode() {
        if (this.selection.length === 0) {
          this.$message.error("请选择至少一行记录");
          return;
        }
        let ids = this.selection.map(item => item.pkid).join(",");
        window.open("http://emes.stepelectric.com/WinOpenASPX/PurchasePrintCable.aspx?SystemNo=" + ids);
      },
    },
  };
</script>
<style lang="scss">
.toolbar {
  .el-checkbox__label {
    font-size: 13px;
  }
}
</style>
